import React from 'react';
import { Lock, LogIn, UserPlus } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useAuth } from '../../hooks/useAuth';
import { getAuthLabels, LOGIN_URL, REGISTER_URL } from '../../config/app';

/**
 * Gates its children behind registration. Authenticated visitors (per the
 * shared cross-subdomain cookie) see the content; everyone else sees a wall
 * that sends them to the cabinet to log in or register.
 */
export default function RegistrationGate({ children }) {
  const { language } = useLanguage();
  const authed = useAuth();
  const labels = getAuthLabels(language);

  if (authed) return children;

  return (
    <div className="bg-white min-h-screen flex items-center justify-center px-4 py-20">
      <div className="max-w-md w-full text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-graweo-sand mb-6">
          <Lock className="w-8 h-8 text-graweo-terra" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold font-manrope text-graweo-chocolate mb-3">
          {labels.gate_title}
        </h1>
        <p className="text-graweo-chocolate/70 mb-8">
          {labels.gate_text}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={REGISTER_URL}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-graweo-terra hover:bg-graweo-chocolate text-white font-semibold rounded-lg transition-colors"
          >
            <UserPlus className="w-4 h-4" />
            {labels.gate_register}
          </a>
          <a
            href={LOGIN_URL}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-graweo-sand text-graweo-chocolate hover:bg-graweo-sand font-semibold rounded-lg transition-colors"
          >
            <LogIn className="w-4 h-4" />
            {labels.gate_login}
          </a>
        </div>
      </div>
    </div>
  );
}
